// -----------------------------------------------------------------------------
// Central config — flip `visible: false` to hide any offer without deleting code.
// -----------------------------------------------------------------------------

export const SITE = {
    name: "Exotik Trips",
    tagline: "Vivez Maurice autrement",
    whatsapp: {
        number: "+230 5743 8178",
        link: "23057438178",
    },
    phone: "+262 262 66 79 70",
    email: "sandrine@ektinvest.com",
    location: "Trou d'Eau Douce, Île Maurice",
    address: {
        streetAddress: "",
        locality: "Trou d'Eau Douce",
        region: "Flacq",
        country: "MU",
    },
    instagram: "#",
    facebook: "#",
    tiktok: "#",
    logoPrimaryUrl:
        "https://customer-assets-wrfwihn1.emergentagent.net/job_exotik-trips/artifacts/snwo7tso_EXOTIK%20TRIPS_LOGO%20PRIMAIRE.png",
    logoSecondaryUrl:
        "https://customer-assets-wrfwihn1.emergentagent.net/job_exotik-trips/artifacts/hx3ccom5_EXOTIK%20TRIPS_LOGO%20SECONDAIRE.png",
    symbolUrl:
        "https://customer-assets-wrfwihn1.emergentagent.net/job_exotik-trips/artifacts/5hlgxltl_EXOTIK%20TRIPS_SYMBOLE%20png.png",
    logoUrl:
        "https://customer-assets-wrfwihn1.emergentagent.net/job_exotik-trips/artifacts/snwo7tso_EXOTIK%20TRIPS_LOGO%20PRIMAIRE.png",
    // Public site URL — used for canonical / sitemap. Update to production domain.
    siteUrl: "https://exotiktrips.com",
    // Analytics — put real IDs here or via env; empty = script skipped.
    analytics: {
        ga4MeasurementId: "",
        metaPixelId: "",
    },
};

export const buildWaLink = (message = "") => {
    const base = `https://wa.me/${SITE.whatsapp.link}`;
    return message ? `${base}?text=${encodeURIComponent(message)}` : base;
};

// -----------------------------------------------------------------------------
// FEATURE FLAG — set visible=true to reactivate an offer/section.
// -----------------------------------------------------------------------------
export const FEATURE_FLAGS = {
    showTestimonials: false, // reactivate when real reviews are collected
};

export const EXPERIENCES = [
    {
        id: "boat",
        visible: true,
        title: "Sorties bateau",
        kicker: "Lagons & Îles",
        excerpt:
            "5 Îles de l'Est, sortie pêche, parachute ascensionnel — le lagon depuis Trou d'Eau Douce.",
        image: "https://images.pexels.com/photos/36267908/pexels-photo-36267908.jpeg",
        span: "lg:col-span-7 lg:row-span-2",
        height: "h-[420px] lg:h-[640px]",
        hasDetail: true,
    },
    {
        id: "offroad",
        visible: false,
        title: "Road trip pickup",
        kicker: "Off-road & Jungle",
        excerpt:
            "Itinéraires sauvages en pickup 4x4 — cascades cachées, plages secrètes, montagnes du Sud.",
        image: "https://images.pexels.com/photos/761815/pexels-photo-761815.jpeg",
        span: "lg:col-span-5",
        height: "h-[300px] lg:h-[310px]",
        hasDetail: false,
    },
    {
        id: "distillery",
        visible: false,
        title: "Distillerie de rhum",
        kicker: "Dégustation locale",
        excerpt:
            "Visite privée des plus belles distilleries — Chamarel, Saint Aubin, l'art du rhum mauricien.",
        image: "https://images.pexels.com/photos/20876379/pexels-photo-20876379.jpeg",
        span: "lg:col-span-5",
        height: "h-[300px] lg:h-[320px]",
        hasDetail: false,
    },
    {
        id: "custom",
        visible: false,
        title: "Sur mesure",
        kicker: "Conciergerie privée",
        excerpt:
            "Une vision, une date, un budget — nous orchestrons l'expérience signature qui vous ressemble.",
        image: "https://images.pexels.com/photos/12194603/pexels-photo-12194603.jpeg",
        span: "lg:col-span-12",
        height: "h-[360px] lg:h-[420px]",
        hasDetail: false,
    },
];

export const OFFERS = [
    {
        id: "decouverte",
        name: "Découverte",
        price: "Rs 1,500",
        tag: "Mise en relation",
        featured: false,
        bullets: [
            "Mise en relation avec nos prestataires",
            "Organisation simple",
            "Confirmation par WhatsApp",
            "Paiement directement au prestataire",
        ],
        en: {
            name: "Discovery",
            tag: "Referral",
            bullets: [
                "Connection with our trusted providers",
                "Simple organisation",
                "WhatsApp confirmation",
                "Pay the provider directly",
            ],
        },
    },
    {
        id: "optimisee",
        name: "Expérience optimisée",
        price: "Rs 3,000",
        tag: "★  Le plus choisi",
        featured: true,
        bullets: [
            "Organisation complète de A à Z",
            "Conseils personnalisés selon vos envies",
            "Assistance WhatsApp dédiée",
            "Coordination avec les prestataires",
            "Itinéraire optimisé",
        ],
        en: {
            name: "Optimised Experience",
            tag: "★  Most popular",
            bullets: [
                "Complete organisation from A to Z",
                "Personalised advice based on your wishes",
                "Dedicated WhatsApp assistance",
                "Coordination with providers",
                "Optimised itinerary",
            ],
        },
    },
    {
        id: "exclusive",
        name: "Expérience exclusive",
        price: "Rs 5,000+",
        tag: "Premium",
        featured: false,
        bullets: [
            "Organisation 100% sur mesure",
            "Expérience premium signature",
            "Assistance prioritaire 24/7",
            "Kit confort offert (serviettes, crème solaire)",
            "Suivi avant / pendant / après",
        ],
        en: {
            name: "Exclusive Experience",
            bullets: [
                "100% tailor-made organisation",
                "Signature premium experience",
                "Priority 24/7 assistance",
                "Comfort kit included (towels, sunscreen)",
                "Follow-up before / during / after",
            ],
        },
    },
];

export const ADDONS = [
    { id: "champagne", name: "Champagne", category: "Célébration", desc: "Bouteille fraîche & flûtes", image: "https://images.pexels.com/photos/2145/sea-sunset-beach-couple.jpg", en: { name: "Champagne", category: "Celebration", desc: "Chilled bottle & flutes" } },
    { id: "cake", name: "Gâteau d'anniversaire", category: "Célébration", desc: "Pâtisserie locale personnalisée", image: "https://images.unsplash.com/photo-1535254973040-607b474cb50d?w=1200&q=80", en: { name: "Birthday cake", category: "Celebration", desc: "Personalised local pastry" } },
    { id: "charcuterie", name: "Plateau charcuterie", category: "Gourmet", desc: "Sélection fromages & charcuterie", image: "https://images.pexels.com/photos/6004727/pexels-photo-6004727.jpeg", en: { name: "Charcuterie board", category: "Gourmet", desc: "Cheese & charcuterie selection" } },
    { id: "deco", name: "Décoration", category: "Ambiance", desc: "Mise en scène pour l'occasion", image: "https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=1200&q=80", en: { name: "Decoration", category: "Ambience", desc: "Styling for the occasion" } },
    { id: "photographer", name: "Photographe", category: "Souvenir", desc: "Souvenirs en haute définition", image: "https://images.unsplash.com/photo-1502920917128-1aa500764cbd?w=1200&q=80", en: { name: "Photographer", category: "Memories", desc: "High-definition memories" } },
    { id: "drone", name: "Drone aérien", category: "Souvenir", desc: "Plans cinéma de votre journée", image: "https://images.pexels.com/photos/1705252/pexels-photo-1705252.jpeg", en: { name: "Aerial drone", category: "Memories", desc: "Cinema-style shots of your day" } },
    { id: "beachkit", name: "Kit plage", category: "Confort", desc: "Serviettes, crème, accessoires", image: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=1200&q=80", en: { name: "Beach kit", category: "Comfort", desc: "Towels, sunscreen, accessories" } },
];

export const TESTIMONIALS = [
    { name: "Camille & Antoine", role: "Lune de miel — Paris", text: "Une journée orchestrée à la perfection. Depuis le champagne au coucher de soleil jusqu'à la coordination du photographe, tout était fluide.", en: { role: "Honeymoon — Paris", text: "A day orchestrated to perfection. From champagne at sunset to the photographer's coordination, everything was seamless." } },
    { name: "Yacine M.", role: "Voyage entre amis — Lyon", text: "Une des plus belles journées de ma vie. Exotik Trips connaît des spots que personne ne montre.", en: { role: "Trip with friends — Lyon", text: "One of the most beautiful days of my life. Exotik Trips knows spots nobody else shows you." } },
    { name: "Sofia R.", role: "Anniversaire 30 ans — Genève", text: "Plateau charcuterie, gâteau, déco, photographe — tout était parfaitement préparé. Une équipe à l'écoute, présente, vraiment premium.", en: { role: "30th birthday — Geneva", text: "Charcuterie board, cake, decoration, photographer — everything was perfectly prepared. An attentive, present, truly premium team." } },
];

// -----------------------------------------------------------------------------
// Boat excursions — full data used by cards, detail modal, and dedicated pages.
// -----------------------------------------------------------------------------
export const BOAT_EXCURSIONS = [
    {
        id: "5iles",
        slug: "excursion-5-iles-est-maurice",
        name: "Excursion 5 Îles de l'Est",
        shortName: "5 Îles de l'Est",
        tagline: "Journée en bateau privé au départ de Trou d'Eau Douce",
        badge: "Lagons & Îles",
        cardDescription:
            "Bateau privé pour votre groupe — 5 îles de l'Est, cascade et déjeuner BBQ sur l'île.",
        image: "https://customer-assets-wrfwihn1.emergentagent.net/job_exotik-trips/artifacts/7z379syn_Image%20ChatGPT%2029%20sept.%202026%2C%2010_15_54.png",
        imageAlt:
            "Deux speedboats Exotik Trips au coucher de soleil sur la plage de Trou d'Eau Douce, côte Est de Maurice",
        fromPrice: 18000,
        fromLabel: "Rs 18 000 pour 4 personnes",
        basePrice: 18000,
        includedPax: 4,
        extraPerPax: 1500,
        endsAt: "15h30",
        priceBanner:
            "Bateau privé pour 4 personnes : Rs 18 000, déjeuner et boissons au repas inclus. Rs 1 500 par personne supplémentaire.",
        catchPhrases: [
            "Pas de groupe de 30 : votre bateau, votre rythme, votre journée.",
            "Déjeuner BBQ sur l'île, boissons servies au repas.",
        ],
        program: [
            "Embarquement au débarcadère de Trou d'Eau Douce",
            "Navigation le long de la côte Sud-Est de Maurice",
            "Observation des dauphins (non garantie)",
            "Île au Phare (Île aux Fouquets) — visite",
            "Île de la Passe — passage",
            "Île aux Marianne — passage",
            "Île aux Aigrettes — snorkeling",
            "Île aux Mangénie (Ilot Mangenie) — déjeuner BBQ avec boissons servies sur l'île",
            "Cascade Grand River South East",
            "Île aux Cerfs — baignade",
            "Fin de l'excursion à 15h30",
        ],
        lunchIncluded: true,
        premiumSupplement: 1200,
        drinks:
            "2 à 3 bières par personne, rhum, Coca-Cola, jus et eau — servies au déjeuner",
        seo: {
            title:
                "Excursion 5 Îles de l'Est en speedboat depuis Trou d'Eau Douce | Exotik Trips",
            description:
                "5 îles de l'Est en bateau privé : Île aux Cerfs, Aigrettes, cascade de Grand River. Rs 18 000 pour 4, déjeuner inclus.",
        },
        en: {
            name: "5 East Islands Excursion",
            shortName: "5 East Islands",
            tagline: "A full day on a private boat from Trou d'Eau Douce",
            badge: "Lagoons & Islands",
            cardDescription:
                "Private boat for your group — 5 islands of the East, waterfall and BBQ lunch on the island.",
            imageAlt:
                "Two Exotik Trips speedboats at sunset on Trou d'Eau Douce beach, East coast of Mauritius",
            fromLabel: "Rs 18,000 for 4 people",
            endsAt: "3:30 PM",
            priceBanner:
                "Private boat for 4 people: Rs 18,000, lunch and drinks with the meal included. Rs 1,500 per additional person.",
            catchPhrases: [
                "No groups of 30: your boat, your pace, your day.",
                "BBQ lunch on the island, drinks served with the meal.",
            ],
            program: [
                "Boarding at the Trou d'Eau Douce jetty",
                "Cruise along the South-East coast of Mauritius",
                "Dolphin watching (not guaranteed)",
                "Île au Phare (Île aux Fouquets) — visit",
                "Île de la Passe — pass by",
                "Île aux Marianne — pass by",
                "Île aux Aigrettes — snorkelling",
                "Île aux Mangénie (Ilot Mangenie) — BBQ lunch with drinks served on the island",
                "Grand River South East waterfall",
                "Île aux Cerfs — swim",
                "Trip ends at 3:30 PM",
            ],
            drinks:
                "2 to 3 beers per person, rum, Coca-Cola, juice and water — served with lunch",
            seo: {
                title: "5 East Islands Speedboat Excursion from Trou d'Eau Douce | Exotik Trips",
                description:
                    "5 islands of the East by private boat: Île aux Cerfs, Aigrettes, Grand River waterfall. Rs 18,000 for 4, lunch included.",
            },
        },
    },
    {
        id: "peche",
        slug: "sortie-peche-en-mer-maurice",
        name: "Sortie de pêche en mer",
        shortName: "Sortie de pêche",
        tagline: "4 heures au large de Trou d'Eau Douce",
        badge: "Pêche",
        cardDescription:
            "Pêche en mer à la traîne et au fond, équipement fourni. Départ Trou d'Eau Douce.",
        image: "https://images.unsplash.com/photo-1544551763-77ef2d0cfc6c?auto=format&fit=crop&w=1600&q=80",
        imageAlt:
            "Bateau Exotik Trips en sortie pêche en mer au départ de Trou d'Eau Douce, côte Est de Maurice",
        fromPrice: 16000,
        fromLabel: "Rs 16 000 pour 4 personnes",
        basePrice: 16000,
        includedPax: 4,
        extraPerPax: 1000,
        departure: "10h30",
        duration: "4h",
        priceBanner:
            "Bateau privé pour 4 personnes : Rs 16 000. Rs 1 000 par personne supplémentaire. Déjeuner en option.",
        program: [
            "Départ à 10h30 depuis le débarcadère de Trou d'Eau Douce",
            "Navigation vers les zones de pêche du large",
            "Pêche à la traîne et au fond avec équipement fourni",
            "Retour prévu vers 14h30",
        ],
        lunchIncluded: false,
        lunchOptionPrice: 1000,
        premiumSupplement: 1200,
        seo: {
            title:
                "Sortie pêche en mer dans l'Est de Maurice, 4h | Exotik Trips",
            description:
                "Sortie pêche en mer, 4h au départ de Trou d'Eau Douce. Bateau privé, équipement fourni. Rs 16 000 pour 4 personnes.",
        },
        en: {
            name: "Deep-Sea Fishing Trip",
            shortName: "Fishing Trip",
            tagline: "4 hours off Trou d'Eau Douce",
            badge: "Fishing",
            cardDescription:
                "Deep-sea trolling and bottom fishing, equipment provided. Departure from Trou d'Eau Douce.",
            imageAlt:
                "Exotik Trips boat on a deep-sea fishing trip from Trou d'Eau Douce, East coast of Mauritius",
            fromLabel: "Rs 16,000 for 4 people",
            departure: "10:30 AM",
            priceBanner:
                "Private boat for 4 people: Rs 16,000. Rs 1,000 per additional person. Lunch optional.",
            program: [
                "Departure at 10:30 AM from the Trou d'Eau Douce jetty",
                "Cruise to the offshore fishing grounds",
                "Trolling and bottom fishing with equipment provided",
                "Return around 2:30 PM",
            ],
            seo: {
                title: "Deep-Sea Fishing Trip in the East of Mauritius, 4h | Exotik Trips",
                description:
                    "Deep-sea fishing trip, 4 hours from Trou d'Eau Douce. Private boat, equipment provided. Rs 16,000 for 4 people.",
            },
        },
    },
    {
        id: "parachute",
        slug: "parachute-ascensionnel-maurice",
        name: "Parachute ascensionnel",
        shortName: "Parachute",
        tagline: "Le lagon vu du ciel",
        badge: "Activité en mer",
        cardDescription:
            "Envol tandem au-dessus du lagon de l'Est. Vue panoramique unique sur la côte.",
        image: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=1600&q=80",
        imageAlt:
            "Parachute ascensionnel tandem au-dessus du lagon turquoise de l'Est de Maurice",
        fromPrice: 2800,
        fromLabel: "Rs 2 800 pour 2 personnes",
        basePrice: 2800,
        includedPax: 2,
        extraPerPax: null,
        priceBanner: "Rs 2 800 pour 2 personnes en tandem.",
        program: [
            "Briefing sécurité au départ",
            "Envol tandem au-dessus du lagon",
            "Vue panoramique unique sur la côte Est",
            "Souvenir inoubliable — photos souvenir en option",
        ],
        lunchIncluded: false,
        seo: {
            title: "Parachute ascensionnel à Maurice | Exotik Trips",
            description:
                "Parachute ascensionnel tandem au-dessus du lagon de l'Est de Maurice. Rs 2 800 pour 2 personnes.",
        },
        en: {
            name: "Parasailing",
            shortName: "Parasailing",
            tagline: "The lagoon seen from the sky",
            badge: "Sea Activity",
            cardDescription:
                "Tandem flight above the East lagoon. A unique panoramic view of the coast.",
            imageAlt:
                "Tandem parasailing above the turquoise lagoon of the East of Mauritius",
            fromLabel: "Rs 2,800 for 2 people",
            priceBanner: "Rs 2,800 for 2 people in tandem.",
            program: [
                "Safety briefing before departure",
                "Tandem flight above the lagoon",
                "Unique panoramic view of the East coast",
                "Unforgettable memory — souvenir photos optional",
            ],
            seo: {
                title: "Parasailing in Mauritius | Exotik Trips",
                description:
                    "Tandem parasailing above the East lagoon of Mauritius. Rs 2,800 for 2 people.",
            },
        },
    },
];
